export const BACKFILL_STATUS = {
  LOADING: 'loading',
  DONE: 'done',
  ERROR: 'error',
};

export const DEVICE_BACKFILL_STATUS = {
  READY: 'ready',
  LOADING: 'loading',
  ERROR: 'error',
};
